import { isRSAA, CALL_API } from 'redux-api-middleware';

/**
 * Simple Redux middleware to patch up `redux-api-middleware` actions.
 *
 * The API middleware will pass `headers` as `undefined` to `fetch` unless we explicitly
 * passes an `headers` object to the action.
 *
 * This is fine in most browsers, but iOS 10.3 (beta as of now), and WebKit
 * nightly has introduced the `fetch` API nativly, so a polyfill is no longer needed, but it throws
 * when `headers` is `undefined`.
 *
 * This middleware ensures that all API actions sends an empty `headers` object if `headers` is
 * undefined.
 */
export default function patchApiMiddleware() {
    return (/* store */) => (next) => (action) => {
        if (isRSAA(action) && action[CALL_API].headers === undefined) {
            Object.assign(action[CALL_API], {
                headers: {},
            });
        }

        return next(action);
    };
}



/** WEBPACK FOOTER **
 ** /src/shared/redux/middlewares/patchApiMiddleware.js
 **/